export default __webpack_public_path__ + "static/media/success.77e758ab.svg";